import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Modal from '../../shared/modals/modal.component';

import {
  hideChartModalForImport, importChartOfAccounts,
} from './store/actions';
import { requiredWhenPresent } from '../../shared/propTypes';
import { PeriodPropTypes } from '../shared/propTypes';

class ImportChartModal extends PureComponent {
  static propTypes = {
    period: PeriodPropTypes,
    chartName: requiredWhenPresent(['isVisible'], PropTypes.shape({
      value: PropTypes.string.isRequired,
    })),
    hideModal: PropTypes.func.isRequired,
    importChart: PropTypes.func.isRequired,
    isVisible: PropTypes.bool.isRequired,
  };

  hideModal = () => {
    const { hideModal } = this.props;

    hideModal();
  };

  importFile = async event => {
    const { hideModal, importChart, chartName, period } = this.props;
    const file = event.target.files[0];
    event.target.value = '';

    importChart({
      file,
      chartName: chartName.value,
      periodName: period.name,
    });
    hideModal();
  };

  render() {
    const {
      chartName,
      isVisible,
    } = this.props;

    return (
      <Modal
        className="import-chart-modal"
        title={`Chart Name: ${chartName && chartName.value}`}
        dismissText="Cancel"
        submitText="Select File to Import"
        closeAction={this.hideModal}
        dismissAction={this.hideModal}
        submitAction={this.importFile}
        isVisible={isVisible}
        withUpload
      >
        <div>
          Import file must have the following Excel format:<br/><br/>
          Chart data must be on the first sheet.<br/>
          Column 1: Local Account<br/>
          Column 2: Local Account Description<br/>
          Column 3: Account<br/>
          Column 4 (optional, not imported): Account Description<br/><br/>
          Warning: All rows of the current chart will be removed and replaced with the imported chart.
        </div>
      </Modal>
    );
  }
}

export default connect(
  null,
  {
    importChart: importChartOfAccounts,
    hideModal: hideChartModalForImport,
  }
)(ImportChartModal);
